import React, { Component } from 'react';
import Title from '../components/Title';

/**
 * Returns a Component with an injected Title Component.
 *
 * @param { Component } HocComponent - Component to add title
 * @param { string } title
 *
 * @example
 *
 * import LoginPage from './containers/LoginPage'
 * const Login = withTitle(LoginPage, 'Login · GA Connector')
 */

const withTitle = (HocComponent, title) =>
  class WithTitle extends Component {
    render() {
      return (
        <React.Fragment>
          <Title title={title} />
          <HocComponent {...this.props} />
        </React.Fragment>
      );
    }
  };

export default withTitle;
